// Compact chart legend: a row of colored dots with their labels.
import { Box, Flex, Text, useColorModeValue } from "@chakra-ui/react";

/**
 * Renders a centered legend from a list of color/label items.
 * @param {Object} props - items ([{color, label}])
 * @returns {React.ReactElement}
 */
export default function ChartLegend({ items }) {
  const textColor = useColorModeValue("secondaryGray.700", "white");
  return (
    <Flex justify="center" gap="20px" mt="10px">
      {items.map((it, idx) => (
        <Flex key={idx} align="center" gap="6px">
          <Box w="10px" h="10px" borderRadius="full" bg={it.color} />
          <Text fontSize="xs" color={textColor}>{it.label}</Text>
        </Flex>
      ))}
    </Flex>
  );
}
